import { render, staticRenderFns } from "./edit-cmsContent.vue?vue&type=template&id=988fc280&scoped=true"
import script from "./edit-cmsContent.vue?vue&type=script&lang=ts"
export * from "./edit-cmsContent.vue?vue&type=script&lang=ts"
import style0 from "./edit-cmsContent.vue?vue&type=style&index=0&id=988fc280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988fc280",
  null
  
)

export default component.exports